import Vue from 'vue';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class WebRequestResultService {
    private baseAPI = process.env.VUE_APP_API_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();

    constructor() {
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getTaxWeightRequestResultByUketsukeCd( param: any ) {

        let q = "";
        let query: string[] = [];
        if (param) { 
            Object.keys(param).forEach((key: string) => {
                if (param[key]) {
                    query.push(`${key}=${param[key]}`);
                }
            });
        }
        if (query.length) {
            q = `?${query.join("&")}`;
        }
        const { result, error } = await this.commonService.get(`${this.baseAPI}/admin/taxweightrequestresult${q}`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getTaxWeightRequestResult');
            return;
        }
    }

    // ============================
}
